import React, {
  Suspense,
  lazy,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react";
import axios from "axios";
import "../../css/site.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  GET_LINKFEATURE_API,
  GET_SAVELINKFEATURE_API,
} from "../../services/api";
import AdsyStore from "../../store/AdsyStore";
import { extractDomain } from "../../../helperJs/helper";
import FallbackLoader from "../../../Mycomponent/share/components/FallbackLoader";

const SiteTable = lazy(() =>
  import("../../share/components/site/site-table.component")
);

function Site() {
  const location = useLocation();
  const tabMenus = ["All Websites", "Interest shown"];
  const queryParams = new URLSearchParams(location.search);
  const domainByQuery = queryParams.get("domain")
    ? queryParams.get("domain")
    : "";

  const [selectedTab, setSelectedTab] = useState(1);
  const [tableLoader, setTableLoader] = useState(true);

  const email = useSelector((state) => state.email);
  const { get_link_feature } = AdsyStore((state) => state);

  const getLinkFeature = async () => {
    if (!email) return;
    setTableLoader(true);
    try {
      const resp = await axios.get(GET_LINKFEATURE_API());
      const resp2 = await axios.get(GET_SAVELINKFEATURE_API(email));

      AdsyStore.setState({
        get_link_feature: {
          links: resp.data,
          save_links: resp2.data,
        },
      });
    } catch (error) {
      AdsyStore.setState({
        get_link_feature: {
          links: [],
          save_links: [],
        },
      });
    } finally {
      setTableLoader(false);
    }
  };

  useEffect(() => {
    getLinkFeature();
  }, [email]);

  const linksData = useMemo(() => {
    if (!get_link_feature.links || get_link_feature?.links.length === 0)
      return [];
    const isUrlPresent = (url) => {
      if (
        !get_link_feature?.save_links ||
        get_link_feature?.save_links?.length === 0
      )
        return false;
      // Use Array.prototype.some to iterate through the array and its nested data arrays.
      return get_link_feature?.save_links?.some((item) =>
        item.data.some((entry) => entry.URL === url)
      );
    };

    return get_link_feature?.links?.map((item) => {
      return {
        ...item,
        domain: extractDomain(item.URL),
        interested: isUrlPresent(item.URL),
        dr: Number(item.DR) || 0,
        traffic: Number(item.Traffic) || 0,
        da: Number(item.DA) || 0,
        cf: 0,
        tf: 0,
        ss: 0,
        price: item.Cost || 0,
        link_type: item.Status,
        categories: item?.Niche
          ? item.Niche.split(/[,/]/)
              .map((c) => c.trim())
              .filter(Boolean)
          : [],
      };
    });
  }, [get_link_feature]);

  const saveLinksData = useMemo(() => {
    if (
      !get_link_feature?.save_links ||
      get_link_feature?.save_links?.length === 0
    )
      return [];
    return get_link_feature?.save_links?.map((item) => {
      const obj = item.data?.[0];
      return {
        ...obj,
        domain: extractDomain(obj.URL),
        interested: true,
        dr: Number(obj.DR) || 0,
        traffic: Number(obj.Traffic) || 0,
        da: Number(obj.DA) || 0,
        cf: 0,
        tf: 0,
        ss: 0,
        price: obj.Cost || 0,
        link_type: obj.Status,
        categories: obj?.Niche
          ? obj.Niche.split(/[,/]/)
              .map((c) => c.trim())
              .filter(Boolean)
          : [],
      };
    });
  }, [get_link_feature]);

  const handleTabOption = useCallback((value) => setSelectedTab(value), []);

  return (
    <div className="w-100 main-pd" id="backlink_info_page">
      <div className="backlink-info-header">
        <h1 className="page-title mb-2">Websites</h1>
        <div className="w-100 mb-4 d-flex align-items-center flex-wrap gap-3">
          <ul className="tab-bar-menu">
            {tabMenus.map((label, index) => (
              <li
                key={index}
                className={selectedTab === index + 1 ? "actives" : ""}
              >
                <button
                  className="tab-bar-menu-button "
                  onClick={() => handleTabOption(index + 1)}
                  style={{
                    fontSize: "14px",
                    fontWeight: "550",
                    color: "black",
                  }}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
          {linksData?.length === 0 ? null : (
            <div
              className="ms-auto"
              style={{ fontWeight: "550", color: "#6C6E79" }}
            >
              Total Publishers:{" "}
              <b style={{ color: "black" }}>{linksData?.length || 0}</b>
            </div>
          )}
        </div>
      </div>

      <section className="sites mt-2">
        {selectedTab === 1 ? (
          <>
            <Suspense fallback={<FallbackLoader />}>
              <SiteTable
                domain={domainByQuery}
                data={linksData}
                tableLoader={tableLoader}
              />
            </Suspense>
          </>
        ) : selectedTab === 2 ? (
          <Suspense fallback={<FallbackLoader />}>
            <SiteTable
              domain={domainByQuery}
              data={saveLinksData}
              tableLoader={tableLoader}
              interestedBtnHide={true}
            />
          </Suspense>
        ) : (
          <h6>Exclude sites I've worked with</h6>
        )}
      </section>
    </div>
  );
}

export default Site;
